enum FormName {
  ReturnPolicyForm = 'returnPolicyForm',
}

export default FormName;
